import setCss from './set-css'
import StrictObj from './strict-obj'
import extractRawElm from './extract-raw-elm'

import { uniqueId } from 'lodash-es'

const UNIQ_CLASS = uniqueId('ggs-draw-rectangle')

export function removeLines($cntr) {
  const cntr = extractRawElm($cntr)
  const lines = cntr.getElementsByClassName(UNIQ_CLASS)
  for (let index = lines.length - 1; index >= 0; index--) {
    const elm = lines[index]
    cntr.removeChild(elm)
  }
}

export function drawArea(
  $cntr,
  areaWidth,
  areaHeight,
  cntrWidth,
  cntrHeight,
  color,
  xOffset = 0,
  yOffset = 0) {

  const topRight = StrictObj({
    x: Math.round(cntrWidth / 2 + areaWidth / 2) + xOffset,
    y: Math.round(cntrHeight / 2 + areaHeight / 2) + yOffset
  })

  const btmLeft = StrictObj({
    x: Math.round(cntrWidth / 2 - areaWidth / 2) + xOffset,
    y: Math.round(cntrHeight / 2 - areaHeight / 2) + yOffset
  })

  return drawRectangle($cntr, topRight, btmLeft, color)
}

export function drawRectangle($cntr, topRight, btmLeft, color) {
  drawLine($cntr, btmLeft.x, topRight.y, Math.abs(topRight.x - btmLeft.x), 3, color, UNIQ_CLASS)
  drawLine($cntr, topRight.x, btmLeft.y, 3, Math.abs(topRight.y - btmLeft.y), color, UNIQ_CLASS)
  drawLine($cntr, btmLeft.x, btmLeft.y, Math.abs(topRight.x - btmLeft.x), 3, color, UNIQ_CLASS)
  drawLine($cntr, btmLeft.x, btmLeft.y, 3, Math.abs(topRight.y - btmLeft.y), color, UNIQ_CLASS)
}

export function drawLine($cntr, left, top, width, height, color, className) {
  const div = document.createElement('div')
  div.classList.add(className)
  setCss(div, {
    position: 'absolute',
    'background-color': color,
    'z-index': 65535,
    top,
    left,
    width,
    height
  })

  const cntr = extractRawElm($cntr)
  cntr.appendChild(div)
}
